export default {
    locked: 'Performance PRO',
    lockedTitle: 'This feature is part of Performance PRO',
    lockedMessage:
        'Your plan includes self-assessment and 360 feedback. Upgrade to Performance PRO to use this feature.',
    unlockAction: 'Upgrade to Performance PRO',
};
